// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Recharts = require("recharts");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var AxisData$ReactHooksTemplate = require("./axisData.res.js");
var ChartComponentColor$ReactHooksTemplate = require("./chartComponentColor.res.js");
var GenericChartAttribute$ReactHooksTemplate = require("./genericChartAttribute.res.js");

function PieChartComponent(props) {
  var chartAttribute = props.chartAttribute;
  var x = GenericChartAttribute$ReactHooksTemplate.innerRadius(chartAttribute);
  var innerRadius = x !== undefined ? x : "30%";
  var x$1 = GenericChartAttribute$ReactHooksTemplate.outerRadius(chartAttribute);
  var outerRadius = x$1 !== undefined ? x$1 : "70%";
  var renderToolTip = function (data) {
    var payload = data["payload"];
    if (payload == null) {
      return JsxRuntime.jsx("div", {});
    }
    var newPayload = Js_dict.values(payload);
    var match = newPayload.length;
    if (match === 0) {
      return JsxRuntime.jsx("div", {});
    }
    var payloadData = Js_dict.get(Caml_array.get(newPayload, 0), "payload");
    if (payloadData === undefined) {
      return JsxRuntime.jsx("div", {});
    }
    var x = Js_dict.get(payloadData, "payload");
    if (x !== undefined) {
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("ul", {
                        children: Belt_Array.map(Js_dict.entries(x), (function (param) {
                                var key = param[0];
                                return JsxRuntime.jsxs("li", {
                                            children: [
                                              JsxRuntime.jsx("span", {
                                                    children: String(key)
                                                  }),
                                              JsxRuntime.jsx("span", {
                                                    children: " : "
                                                  }),
                                              JsxRuntime.jsx("span", {
                                                    children: param[1] + (
                                                      String(key) === "Percentage" ? " %" : ""
                                                    )
                                                  })
                                            ],
                                            className: "recharts-tooltip-item py-3-px"
                                          });
                              })),
                        className: "recharts-tooltip-itemlist"
                      }),
                  className: "recharts-default-tooltip bg-white border border-solid border-1 \n            border-gray-300 p-2 w-64 max-w-full text-sm"
                });
    } else {
      return JsxRuntime.jsx("div", {});
    }
  };
  var renderLegend = function (value, param) {
    return JsxRuntime.jsx("span", {
                children: value,
                className: "text-xs"
              });
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Recharts.ResponsiveContainer, {
                    children: JsxRuntime.jsxs(Recharts.PieChart, {
                          width: 100,
                          height: 100,
                          children: [
                            $$Array.of_list(Belt_List.mapWithIndex(GenericChartAttribute$ReactHooksTemplate.yAxis(chartAttribute), (function (i, xs) {
                                        var json = GenericChartAttribute$ReactHooksTemplate.data(chartAttribute);
                                        return JsxRuntime.jsxs(Recharts.Pie, {
                                                    data: GenericChartAttribute$ReactHooksTemplate.data(chartAttribute),
                                                    innerRadius: innerRadius,
                                                    outerRadius: outerRadius,
                                                    fill: "red",
                                                    dataKey: AxisData$ReactHooksTemplate.key(xs),
                                                    nameKey: AxisData$ReactHooksTemplate.key(GenericChartAttribute$ReactHooksTemplate.xAxis(chartAttribute)),
                                                    children: [
                                                      JsxRuntime.jsx(Recharts.LabelList, {
                                                            dataKey: AxisData$ReactHooksTemplate.key(xs),
                                                            position: "top",
                                                            fill: "black",
                                                            fontSize: 12
                                                          }),
                                                      json !== undefined ? Belt_Array.mapWithIndex(Belt_Option.getWithDefault(Js_json.decodeArray(json), []), (function (i, param) {
                                                                return JsxRuntime.jsx(Recharts.Cell, {
                                                                            fill: ChartComponentColor$ReactHooksTemplate.getColorById(i, GenericChartAttribute$ReactHooksTemplate.colors(chartAttribute))
                                                                          }, "cell-" + String(i));
                                                              })) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                    ],
                                                    label: true
                                                  }, String(i));
                                      }))),
                            JsxRuntime.jsx(Recharts.Tooltip, {
                                  contentStyle: {
                                    fontSize: "10pt"
                                  },
                                  content: renderToolTip
                                }),
                            JsxRuntime.jsx(Recharts.Legend, {
                                  formatter: renderLegend
                                })
                          ]
                        })
                  }),
              className: " w-full " + props.chartHeight + " p-4 "
            });
}

var make = PieChartComponent;

exports.make = make;
/* recharts Not a pure module */
